module.exports = __webpack_public_path__ + "static/media/sushi.ef79233d.png";